import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './styles/theme.css';
import './styles/_variables.css';
import './styles/global-fixes.css';
import './styles/policy-theme.css';
import './styles/ea-canvas.css';
// import './i18n';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import './i18n';
import i18n from './i18n';
import { setV2Token } from './utils/setV2Token';

// SSO handoff: when arriving from the onboarding portal (dora_frontend) with a
// `?token=<jwt>` in the URL, store it as the session token and strip it from
// the address bar — so the user lands in TrustLens already authenticated.
// Runs synchronously before render so ProtectedRoute sees the token immediately.
try {
  const params = new URLSearchParams(window.location.search);
  const handoff = params.get('token');
  if (handoff) {
    setV2Token(handoff, true);
    params.delete('token');
    const qs = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash);
  }
} catch {
  // ignore — fall back to normal auth
}

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
     <I18nextProvider i18n={i18n}>
     <App />
     </I18nextProvider>
  </QueryClientProvider>
)